import {IABTestConfiguration} from "@pg-mono/ab-testing";

export enum OngoingABTests {
    MAP_AS_MAIN_VIEW = "MAP_AS_MAIN_VIEW"
}

export enum MapAsMainViewVariant {
    MAIN_VIEW_LIST = 0,
    MAIN_VIEW_MAP = 1
}
/**
 * Example of a test configuration:
 * {
 *     id: "xyz123" // Generated id, received from business,
 *     expires: new Date(2024, 3, 30), // Date when the test will expire,
 *     name: OngoingABTests.SOME_FEATURE, // Name of the test,
 *     path: ["some-path"], // Paths where the test will be active,
 *     matchOnAllPaths: false, // If true, the test will be active on all paths,
 *     sampleRate: 1, // Percentage of users that will be included in the test (0.0 - 1.0)
 *     variants: 3, // Number of variants, the actual amount is variants + 1 (first variant is 0)
 *     withSSR: false // If true, the test will be active on server side rendering
 * }
 */

export const ongoingABTests: IABTestConfiguration[] = [
    {
        id: "arzk99203am7ou0ulmks",
        expires: new Date(2026, 6, 30),
        name: OngoingABTests.MAP_AS_MAIN_VIEW,
        path: [],
        matchOnAllPaths: true,
        variants: 1,
        variantConfig: () => {
            return {
                [MapAsMainViewVariant.MAIN_VIEW_LIST]: 0.7,
                [MapAsMainViewVariant.MAIN_VIEW_MAP]: 0.3
            }; // 30% map as main view, 70% list as main view - base
        },
        withSSR: true
    }
];
import {IABTestConfiguration} from "@pg-mono/ab-testing";

export enum OngoingABTests {
    MAP_AS_MAIN_VIEW = "MAP_AS_MAIN_VIEW"
}

export enum MapAsMainViewVariant {
    MAIN_VIEW_LIST = 0,
    MAIN_VIEW_MAP = 1
}
/**
 * Example of a test configuration:
 * {
 *     id: "xyz123" // Generated id, received from business,
 *     expires: new Date(2024, 3, 30), // Date when the test will expire,
 *     name: OngoingABTests.SOME_FEATURE, // Name of the test,
 *     path: ["some-path"], // Paths where the test will be active,
 *     matchOnAllPaths: false, // If true, the test will be active on all paths,
 *     sampleRate: 1, // Percentage of users that will be included in the test (0.0 - 1.0)
 *     variants: 3, // Number of variants, the actual amount is variants + 1 (first variant is 0)
 *     withSSR: false // If true, the test will be active on server side rendering
 * }
 */

export const ongoingABTests: IABTestConfiguration[] = [
    {
        id: "arzk99203am7ou0ulmks",
        expires: new Date(2026, 6, 30),
        name: OngoingABTests.MAP_AS_MAIN_VIEW,
        path: [],
        matchOnAllPaths: true,
        variants: 1,
        variantConfig: () => {
            return {
                [MapAsMainViewVariant.MAIN_VIEW_LIST]: 0.7,
                [MapAsMainViewVariant.MAIN_VIEW_MAP]: 0.3
            }; // 30% map as main view, 70% list as main view - base
        },
        withSSR: true
    }
];
